import { combineReducers } from 'redux';
import * as types from 'legacy/src/constants/types';

const subjects = (state = [], action) => {
  switch (action.type) {
    case types.SET_ADMIN_SUBJECTS:
      return [...action.adminSubjects];
    default:
      return state;
  }
};

const info = (state = [], action) => {
  switch (action.type) {
    case types.SET_ADMIN_INFO:
      return { ...action.adminInfo };
    default:
      return state;
  }
};

const loading = (state = true, action) => {
  switch (action.type) {
    case types.ADMIN_START_LOADING:
      return action.loading;
    case types.ADMIN_END_LOADING:
      return action.loading;
    default:
      return state;
  }
};

const adminData = combineReducers({
  subjects,
  info,
  loading,
});

export default adminData;
